import React, { useEffect, useState } from "react";
import WidgetHeader from "../../../../components/Widget/Header";
import { useHistory } from 'react-router-dom'
import { Icon, Input } from '@arnsbogroup/react-voicearchive'

const ShortcutsWidget = ({ widget }) => {
  const [title, setTitle] = useState("");
  const history = useHistory()
  const shortcuts = [
    {
      title: 'New Jobs',
      icon: ['fas', 'list'],
      action: () => history.push('/jobs/new'),
      restrictions: true
    },
    {
      title: 'Open Jobs',
      icon: ['fal', 'file-invoice'],
      action: () => history.push('/jobs/open'),
      restrictions: true
    },
    {
      title: 'Closed Jobs',
      icon: ['fa', 'check'],
      action: () => history.push('/jobs/completed'),
      restrictions: true
    },
    {
      title: 'Bookings',
      icon: ['far', 'calendar'],
      action: () => history.push('/bookings'),
      restrictions: true
    },
    {
      title: 'Unavailability',
      icon: ['far', 'calendar-times'],
      action: () => history.push('/talent/profile/availability'),
      restrictions: true
    },
    {
      title: 'Profile',
      icon: ['far', 'user'],
      action: () => history.push('/talent/profile'),
      restrictions: true
    }
  ]

  useEffect(() => {
    setTitle(widget.widgetId.replace(/_/g, " "));
  }, []);

  const widget_id = `ID_${widget.widgetId}`;
  return (
    <li
      className="bg-white border m-4 shadow rounded border-gray-400"
      key={widget_id}
      id={widget_id}
    >
      <WidgetHeader widget={widget} widgetTitle={title} />

      <div className="grid grid-cols-3 gap-4 p-4">
        {shortcuts
        .filter(({ restrictions }) => restrictions)
        .map(({ title, icon, action }) => (
          <div onClick={action} className="shadow p-4 hover:bg-gray-200 cursor-pointer">
            <div className="w-full block text-3xl text-primary text-center">
              <Icon icon={icon} />
            </div>
            <div className="text-lg mt-4 text-gray-900">
              {title}
            </div>
          </div>
        ))}
      </div>
    </li>
  );
};

export default ShortcutsWidget;